/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ChallengeRewardDataFragment = {
  readonly __typename?: 'ChallengeReward';
  readonly id: string;
  readonly name: string;
  readonly expiresAt: any | null;
  readonly terms: string;
  readonly rewardType: Types.RewardType;
  readonly redeemable: boolean | null;
  readonly redeemableAt: any | null;
};

export type ChallengeRewardsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ChallengeRewardsQuery = {
  readonly __typename?: 'Query';
  readonly challengeRewards: ReadonlyArray<{
    readonly __typename?: 'ChallengeReward';
    readonly id: string;
    readonly name: string;
    readonly expiresAt: any | null;
    readonly terms: string;
    readonly rewardType: Types.RewardType;
    readonly redeemable: boolean | null;
    readonly redeemableAt: any | null;
  }>;
};

export const challengeRewardsQueryMock: ExecutionResult<ChallengeRewardsQuery> =
  {
    data: {
      challengeRewards: [
        {
          id: '509e6ea9-fee4-42a9-9625-87ce71904308',
          name: 'Hello World',
          expiresAt: 'DateTime',
          terms: 'Hello World',
          rewardType: 'NON_PREMIUM',
          redeemable: true,
          redeemableAt: 'DateTime',
        },
        {
          id: 'a7a7163b-a7ed-4a96-a8a1-85e3da00a9a4',
          name: 'Hello World',
          expiresAt: 'DateTime',
          terms: 'Hello World',
          rewardType: 'NON_PREMIUM',
          redeemable: false,
          redeemableAt: 'DateTime',
        },
        {
          id: '534319d0-8060-4b59-aa25-0f9c4016b1bd',
          name: 'Hello World',
          expiresAt: 'DateTime',
          terms: 'Hello World',
          rewardType: 'NON_PREMIUM',
          redeemable: false,
          redeemableAt: 'DateTime',
        },
      ],
    },
  };
export const ChallengeRewardDataFragmentDoc = gql`
  fragment ChallengeRewardData on ChallengeReward {
    id
    name
    expiresAt
    terms
    rewardType
    redeemable
    redeemableAt
  }
`;
export const ChallengeRewardsDocument = gql`
  query ChallengeRewards {
    challengeRewards {
      ...ChallengeRewardData
    }
  }
  ${ChallengeRewardDataFragmentDoc}
`;

export function useChallengeRewardsQuery(
  options?: Omit<Urql.UseQueryArgs<ChallengeRewardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ChallengeRewardsQuery, ChallengeRewardsQueryVariables>({
    query: ChallengeRewardsDocument,
    ...options,
  });
}
